export default __webpack_public_path__ + "static/media/chevron-left.48453909.svg";